import axios from 'axios';

// Chave da API
const API_KEY = '49ddcd7675591c1a98349db2b61fc21c';
const BASE_URL = 'https://wdapi2.com.br/consulta';

/**--------------------------------------------------
 * Valida o formato da placa (7 caracteres)
 * @param {string} placa - Placa do veículo
 * @returns {boolean} - True se válida
 */
const validarPlaca = (placa) => {
    if (!placa || typeof placa !== 'string') return false;
    const placaLimpa = placa.replace(/[^a-zA-Z0-9]/g, '');
    return placaLimpa.length === 7;
};

/** --------------------------------------------------
 * Extrai até 3 itens com maior score dos dados da FIPE
 * @param {Array} dadosFipe - Array de dados da FIPE
 * @returns {Array} - Até 3 itens com maior score (array vazio se não houver)
 */
const extrairMaiorScore = (dadosFipe) => {
    if (!dadosFipe || !Array.isArray(dadosFipe) || dadosFipe.length === 0) {
        return [];
    }

    return [...dadosFipe]
        .filter((item) => item && typeof item.score === 'number')
        .sort((a, b) => b.score - a.score)
        .slice(0, 3);
};

/** --------------------------------------------------
 * Consulta dados da placa na API FIPE
 * @param {string} placa - Placa do veículo (7 caracteres)
 * @returns {Promise<Object>} - Dados do veículo
 */
export const consultarPlacaFipe = async (placa) => {
    try {
        // Validar placa
        if (!validarPlaca(placa)) {
            throw new Error('Placa inválida. Deve conter 7 caracteres.');
        }

        // Limpar placa (remover caracteres especiais)
        const placaLimpa = placa.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

        // Fazer requisição
        const response = await axios.get(`${BASE_URL}/${placaLimpa}/${API_KEY}`);
        
        if (!response.data) {
            throw new Error('Nenhum dado retornado pela API');
        }

        return response.data;

    } catch (error) {
        console.error('Erro ao consultar placa FIPE:', error);
        throw error;
    }
};

/**--------------------------------------------------
 * Extrai dados específicos do veículo da resposta da API
 * @param {Object} dadosApi - Resposta completa da API
 * @returns {Object} - Dados formatados do veículo
 */
export const extrairDadosVeiculo = (dadosApi) => {
    try {
        if (!dadosApi) {
            throw new Error('Dados da API não fornecidos');
        };

        const dadosExtra = dadosApi.extra?.tipo_veiculo;
        const dadosSegmento = dadosApi?.segmento;
        const dadosSub = dadosApi?.sub_segmento;
        const dadosMarca = dadosApi?.marca;

        const padraoAutomovel = /pick|pick-up|pick up|pickup|camioneta|caminhonete|automovel|auto/i;
        const isAutomovel = padraoAutomovel.test(dadosExtra) || padraoAutomovel.test(dadosSegmento) || padraoAutomovel.test(dadosSub);

        const padraoMotocicleta = /motoneta|moto|motocicleta|SCOOTER|yamaha/i;
        const isMotocicleta = padraoMotocicleta.test(dadosExtra) || padraoMotocicleta.test(dadosSegmento) || padraoMotocicleta.test(dadosSub) || padraoMotocicleta.test(dadosMarca);

        const TipoForm = isAutomovel? 'automovel' : isMotocicleta? 'motocicleta' : '';

        // Extrair até 3 itens com maior score da FIPE
        const itensMaiorScore = extrairMaiorScore(dadosApi.fipe?.dados);
        const UnicoModelo = itensMaiorScore.length === 1? itensMaiorScore[0] : null;

        return {
            modelo: UnicoModelo?.texto_modelo || dadosApi.MODELO || dadosApi.modelo || '',
            anoModelo: UnicoModelo?.ano_modelo || dadosApi.anoModelo || dadosApi.ano_modelo || '',
            cor: dadosApi.cor || '',
            chassi: dadosApi.extra?.chassi || dadosApi.chassi || '',
            tipoVeiculo: TipoForm || '',
            situacao: dadosApi.situacao || '',
            valorFipe: UnicoModelo?.texto_valor || '',
            maioresScoresFipe: UnicoModelo ? [UnicoModelo] : itensMaiorScore,
            marca: UnicoModelo?.texto_marca || dadosApi.MARCA || dadosApi.marca || '',
            placa: dadosApi.placa || '',
            municipio: dadosApi.municipio || '',
            uf: dadosApi.uf || '',
            
        };

    } catch (error) {
        console.error('Erro ao extrair dados do veículo:', error);
        throw error;
    }
};

/**
 * Função principal que consulta e retorna dados formatados
 * @param {string} placa - Placa do veículo
 * @returns {Promise<Object>} - Dados formatados do veículo
 */
export const buscarDadosPlaca = async (placa) => {
    try {
        const dadosApi = await consultarPlacaFipe(placa);
        const dadosFormatados = extrairDadosVeiculo(dadosApi);
        return dadosFormatados;
    } catch (error) {
        console.error('Erro ao buscar dados da placa:', error);
        throw error;
    }
};

// Exportação default para compatibilidade
export default {
    consultarPlacaFipe,
    extrairDadosVeiculo,
    buscarDadosPlaca
};
